import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import '../styles/components/JoinTeam.scss';

const JoinTeam = () => {
    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: true
    });

    return (
        <section id="join-combined" className="join-team-section gradient-bg">
            <div className="section-container" ref={ref}>
                <h2 className={`section-title ${inView ? 'fade-in' : ''}`}>
                    {/* NASIL OWL OLUNUR */}
                </h2>

                <div className={`join-content ${inView ? 'slide-up' : ''}`}>
                    <div className="join-columns">
                        <div className="join-column nasil-content">
                            <div className="nasil-header">
                                {/* <img src="/assets/images/icon-vision.png" alt="NASIL owl olunur?" className="nasil-logo" /> */}
                                <h3 className="text-center">Takım Üyesi Olmak için</h3>
                            </div>

                            <div className="requirements-list">
                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/goal.png" alt="Teamwork" />
                                    </div>
                                    <p>
                                        Rekabetçi arenada bizimle mücadele etmek isteyenler için yüksek standartlar belirliyoruz.
                                        Ulusal ve global düzeydeki başarılarımız temelinde bu yapımız bulunmaktadır.
                                    </p>
                                </div>

                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/talking.png" alt="Skill" />
                                    </div>
                                    <div className="iletisim">
                                        <p>
                                            İletişim becerilerinizin yüksek olması önemlidir.
                                        </p>
                                    </div>

                                </div>


                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/target-audience.png" alt="Achievement" />
                                    </div>
                                    <p>
                                        GamePlay, Aim, GameSense özelliklerinden en az birisinde çok iyi seviyede olmanız beklenir.
                                    </p>
                                </div>

                                <div className="requirement-item">
                                    <div className="requirement-icon">
                                        <img src="/assets/images/support.png" alt="Support" />
                                    </div>
                                    <p>
                                        Destek için herhangi bir <span className="black-text">@BLACK</span> oyuncumuzla iletişime geçebilirsiniz.
                                    </p>
                                </div>
                            </div>

                            <div className="gaming-skills">
                                <p>
                                    Aksi takdirde antrenman, turnuva maçlarında ve kısa pilot oyunlarda takım temposuna ayak uydurmakta zorlanabilirsiniz.
                                </p>
                            </div>

                            <div className="team-expectations">
                                <p>
                                    Takımımız profesyonel ve titiz bir yapıdadır. Eğer uyum sorunu yaşacağınızı düşünüyorsanız Community üyesi olarak aramızda bulunabilirsiniz.
                                </p>
                                <div className="button-group mt-4 text-center">
                                    <Link to="/takimbasvuru" className="gold-button">
                                        Takım Başvuru Formu ve daha fazla bilgi almak için
                                    </Link>
                                </div>
                                {/* <div className="text-center mt-3">
                                    <a href="https://www.blackowls.net" target="_blank" rel="noopener noreferrer" className="website-link">
                                        www.blackowls.net
                                    </a>
                                </div> */}
                            </div>
                            <p className="closing-text">Bol şans!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JoinTeam;